import { useContext } from "react";
import { Filter } from "../../components/Filter/Filter";
import { PaymentContext } from "../../providers/PaymentProvider";

export type AllowableFields = "status" | "startDate" | "endDate" | "customer";

export interface PaymentFilterProps {
  title?: string;
  clearFilterText?: string; // Custom text for the clear filter button
  btnText?: string; // Custom text for the apply filter button
  FilterFieldsLabel?: {
    [key in AllowableFields]?: string; // Custom labels for filter fields
  };
  allowableFields?: AllowableFields[];
}

const PaymentFilter = ({
  title = "Payments",
  clearFilterText = "Clear all Filter",
  btnText = "Apply Filter",
  FilterFieldsLabel = {
    status: "Select Payment Method",
    startDate: "Payment Start Date",
    endDate: "Payment End Date",
    customer: "Select Customer",
  },
  allowableFields = ["status", "startDate", "endDate", "customer"],
}: PaymentFilterProps) => {
  const { handleApplyFilter, handleClearFilter, paymentMethodOptions } =
    useContext(PaymentContext);

  const fieldsToUse: AllowableFields[] = allowableFields;
  return (
    <>
      <Filter
        label={title}
        clearFilterText={clearFilterText}
        allowableFields={fieldsToUse}
        btnText={btnText}
        FilterFieldsLabel={FilterFieldsLabel}
        onApplyFilter={handleApplyFilter}
        statusList={paymentMethodOptions}
        onClearFilter={handleClearFilter}
      />
    </>
  );
};

export default PaymentFilter;
